import { EventDispatcher } from './EventDispatcher';
import VideoSlider from '../components/VideoSlider';
import ContentSlider from '../components/ContentSlider';

export default class ContentModuleController {
    constructor() {
        this.availableModules = {
            videoslider: VideoSlider,
            contentslider: ContentSlider,
        };

        this.modules = {};

        EventDispatcher.on('pageTransition', this.handlePageTransition.bind(this));
    }

    handlePageTransition(e) {
        if (e.detail.namespace === 'after' || e.detail.namespace === 'once') {
            const container = e.detail.container;

            this.checkModules(container);
        }

        if (e.detail.namespace === 'leave') {
            this.destroyModules();
        }
    }

    checkModules(container) {
        container.querySelectorAll('[data-module]').forEach((el) => {
            const name = el.dataset.module;
            const ModuleClass = this.availableModules[name];

            if (ModuleClass) {
                if (!this.modules[name]) this.modules[name] = [];
                const instance = new ModuleClass(el);

                this.modules[name].push(instance);
            }
        });
    }

    destroyModules() {
        Object.values(this.modules).forEach((instances) => {
            if (Array.isArray(instances)) {
                instances.forEach((mod) => {
                    if (mod && typeof mod.destroy === 'function') {
                        mod.destroy();
                    }
                });
            } else {
                if (instances && typeof instances.destroy === 'function') {
                    instances.destroy();
                }
            }
        });
        this.modules = {};
    }
}
